<sol-dropdown class="permission-select"
              [isMultiple]="true"
              [options]="roles"
              [optionsValue]="'RoleId'"
              [optionsLabel]="'DisplayName'"
              [(ngModel)]="checkedRoles"
              (selectionChange)="onValueChange($event)"
              (dropdownOpenStateChange)="onDropdownOpenStateChange($event)">
</sol-dropdown>
